export enum ModuleNames {
	Contracts = 'Contracts',
	Closing = 'Closing',
	Sales = 'Sales',
	Leads = 'CRM',
	PostSale = 'Post Sale'
}